var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.18754 15.929C13.1255 15.929 16.9196 10.1827 16.9196 5.19965C16.9196 5.03646 16.9162 4.87401 16.9089 4.71224C17.6471 4.17819 18.2843 3.51696 18.7904 2.75953C18.1145 3.05993 17.3873 3.26211 16.6243 3.35326C17.4031 2.88643 18.0009 2.14788 18.283 1.26754C17.5425 1.70666 16.7325 2.01622 15.8878 2.18287C15.1995 1.44989 14.2196 0.991455 13.1345 0.991455C11.0515 0.991455 9.3624 2.68021 9.3624 4.76187C9.3624 5.05782 9.39555 5.34559 9.46026 5.62171C6.32535 5.46401 3.54553 3.96346 1.68514 1.68179C1.35006 2.25727 1.17382 2.91132 1.1744 3.57714C1.1744 4.88544 1.84029 6.04037 2.85293 6.71607C2.25394 6.69778 1.6681 6.53603 1.14466 6.24442C1.1441 6.26025 1.1441 6.27567 1.1441 6.29259C1.1441 8.11881 2.44425 9.6436 4.17016 9.9891C3.84601 10.0774 3.51153 10.122 3.17556 10.1218C2.93294 10.1218 2.69648 10.0979 2.46667 10.0538C2.94688 11.5521 4.33932 12.6425 5.99024 12.6729C4.69924 13.6845 3.07299 14.2871 1.30549 14.2871C1.00481 14.2873 0.704384 14.2699 0.405762 14.2348C2.0751 15.3045 4.05709 15.929 6.18754 15.929Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.dbe8af99e1d2d6054173ef0e0ecf3bf8.svg";
export { ForwardRef as ReactComponent };